import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemService } from 'common/services/core_services/system.service';

@Component({
    selector: 'modal-pop-up',
    templateUrl: './modal-pop-up.component.html',
    styleUrls: ['./modal-pop-up.component.scss'],
})
export class ModalPopUpComponent implements OnInit {
    @ViewChild('confirmPopup', { static: true }) confirmPopup: ElementRef;
    @Output() onTogglePopUp = new EventEmitter<boolean>();
    @Input() customClass: string = '';
    @Input() modalSize: string = 'md';
    @Input() showCloseBtn: boolean = true;

    constructor(private modalService: NgbModal, private systemService: SystemService) {}

    ngOnInit() {
        document.body.classList.remove('hide-body-overflow');
        this.modalService.open(this.confirmPopup, {
            centered: true,
            backdrop: 'static',
            keyboard: false,
            size: this.modalSize,
            windowClass: this.customClass,
        });
        document.body.classList.add('hide-modal-body-overflow');
    }

    closeModal() {
        document.body.classList.remove('hide-modal-body-overflow');
        this.modalService.dismissAll();
        this.onTogglePopUp.emit(true);
        this.systemService.showModal = false;
    }
}
